import { notificator } from "@/services/notificator";

export default async (): Promise<void> => {
  await notificator.init();
};
